// Main Screen
export const SELECTED_TAB = "SELECTED_TAB";
export const SELECTED_MODEL = "SELECTED_MODEL";
export const SET_SNACKBAR = "SET_SNACKBAR";

export const SET_CLOSE_MODEL = "SET_CLOSE_MODEL";

// Pagination
export const SELECTED_MODEL_PAGE = "SELECTED_MODEL_PAGE";
export const SELECTED_DRAWING_PAGE = "SELECTED_DRAWING_PAGE";
export const SELECTED_VIEW_PAGE = "SELECTED_VIEW_PAGE";

export const GET_MODELS = "GET_MODELS";
export const GET_MODELS_SUCCESS = "GET_MODELS_SUCCESS";
export const GET_MODELS_FAILURE = "GET_MODELS_FAILURE";

export const CREATE_NEW_MODEL = "CREATE_NEW_MODEL";
export const CREATE_NEW_MODEL_SUCCESS = "CREATE_NEW_MODEL_SUCCESS";
export const CREATE_NEW_MODEL_FAILURE = "CREATE_NEW_MODEL_FAILURE";

export const UPDATE_MODEL = "UPDATE_MODEL";
export const UPDATE_MODEL_SUCCESS = "UPDATE_MODEL_SUCCESS";
export const UPDATE_MODEL_FAILURE = "UPDATE_MODEL_FAILURE";

export const DELETE_MODEL = "DELETE_MODEL";
export const DELETE_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS";
export const DELETE_MODEL_FAILURE = "DELETE_MODEL_FAILURE";

export const SEARCH_VALUE_MODEL = "SEARCH_VALUE_MODEL";
export const SORT_BY_MODEL = "SORT_BY_MODEL";
export const SELECTED_PAGE_MODEL = "SELECTED_PAGE_MODEL";

export const IS_TOUCHED_MODEL = "IS_TOUCHED_MODEL";

export const SET_SHOW_SIDE_PANEL = "SET_SHOW_SIDE_PANEL";

export const GET_REPTEXT = "GET_REPTEXT";
export const GET_REPTEXT_SUCCESS = "GET_REPTEXT_SUCCESS";
export const GET_REPTEXT_FAILURE = "GET_REPTEXT_FAILURE";

export const CREATE_NEW_REPTEXT = "CREATE_NEW_REPTEXT";
export const CREATE_NEW_REPTEXT_SUCCESS = "CREATE_NEW_REPTEXT_SUCCESS";
export const CREATE_NEW_REPTEXT_FAILURE = "CREATE_NEW_REPTEXT_FAILURE";

export const DELETE_REPTEXT = "DELETE_REPTEXT";
export const DELETE_REPTEXT_SUCCESS = "DELETE_REPTEXT_SUCCESS";
export const DELETE_REPTEXT_FAILURE = "DELETE_REPTEXT_FAILURE";

export const UPDATE_REPTEXT = "UPDATE_REPTEXT";
export const UPDATE_REPTEXT_SUCCESS = "UPDATE_REPTEXT_SUCCESS";
export const UPDATE_REPTEXT_FAILURE = "UPDATE_REPTEXT_FAILURE";

export const GET_REGIONS = "GET_REGIONS";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILURE = "GET_REGIONS_FAILURE";

// Data Descriptions
export const GET_DDS = "GET_DDS";
export const GET_DDS_SUCCESS = "GET_DDS_SUCCESS";
export const GET_DDS_FAILURE = "GET_DDS_FAILURE";

export const CREATE_NEW_DD = "CREATE_NEW_DD";
export const CREATE_NEW_DD_SUCCESS = "CREATE_NEW_DD_SUCCESS";
export const CREATE_NEW_DD_FAILURE = "CREATE_NEW_DD_FAILURE";

export const UPDATE_DD = "UPDATE_DD";
export const UPDATE_DD_SUCCESS = "UPDATE_DD_SUCCESS";
export const UPDATE_DD_FAILURE = "UPDATE_DD_FAILURE";

export const DELETE_DD = "DELETE_DD";
export const DELETE_DD_SUCCESS = "DELETE_DD_SUCCESS";
export const DELETE_DD_FAILURE = "DELETE_DD_FAILURE";

export const SEARCH_VALUE_DD = "SEARCH_VALUE_DD";
export const SORT_BY_DD = "SORT_BY_DD";
export const SELECTED_PAGE_DD = "SELECTED_PAGE_DD";

export const IS_TOUCHED_DD = "IS_TOUCHED_DD";

export const GET_CONFIG = "GET_CONFIG";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_FAILURE = "GET_CONFIG_FAILURE";

export const CREATE_NEW_CONFIG = "CREATE_NEW_CONFIG";
export const CREATE_NEW_CONFIG_SUCCESS = "CREATE_NEW_CONFIG_SUCCESS";
export const CREATE_NEW_CONFIG_FAILURE = "CREATE_NEW_CONFIG_FAILURE";

export const CREATE_NEW_DD_VALUE = "CREATE_NEW_DD_VALUE";
export const CREATE_NEW_DD_VALUE_SUCCESS = "CREATE_NEW_DD_VALUE_SUCCESS";
export const CREATE_NEW_DD_VALUE_FAILURE = "CREATE_NEW_DD_VALUE_FAILURE";

export const UPDATE_DD_VALUE = "UPDATE_DD_VALUE";
export const UPDATE_DD_VALUE_SUCCESS = "UPDATE_DD_VALUE_SUCCESS";
export const UPDATE_DD_VALUE_FAILURE = "UPDATE_DD_VALUE_FAILURE";

export const DELETE_DD_VALUE = "DELETE_DD_VALUE";
export const DELETE_DD_VALUE_SUCCESS = "DELETE_DD_VALUE_SUCCESS";
export const DELETE_DD_VALUE_FAILURE = "DELETE_DD_VALUE_FAILURE";

// Views
export const GET_VIEWS = "GET_VIEWS";
export const GET_VIEWS_SUCCESS = "GET_VIEWS_SUCCESS";
export const GET_VIEWS_FAILURE = "GET_VIEWS_FAILURE";

export const CREATE_NEW_VIEW = "CREATE_NEW_VIEW";
export const CREATE_NEW_VIEW_SUCCESS = "CREATE_NEW_VIEW_SUCCESS";
export const CREATE_NEW_VIEW_FAILURE = "CREATE_NEW_VIEW_FAILURE";

export const UPDATE_VIEW = "UPDATE_VIEW";
export const UPDATE_VIEW_SUCCESS = "UPDATE_VIEW_SUCCESS";
export const UPDATE_VIEW_FAILURE = "UPDATE_VIEW_FAILURE";

export const DELETE_VIEW = "DELETE_VIEW";
export const DELETE_VIEW_SUCCESS = "DELETE_VIEW_SUCCESS";
export const DELETE_VIEW_FAILURE = "DELETE_VIEW_FAILURE";

export const SEARCH_VALUE_VIEW = "SEARCH_VALUE_VIEW";
export const SORT_BY_VIEW = "SORT_BY_VIEW";
export const SELECTED_PAGE_VIEW = "SELECTED_PAGE_VIEW";

export const IS_TOUCHED_VIEW = "IS_TOUCHED_VIEW";

// Drawings
export const GET_DRAWINGS = "GET_DRAWINGS";
export const GET_DRAWINGS_SUCCESS = "GET_DRAWINGS_SUCCESS";
export const GET_DRAWINGS_FAILURE = "GET_DRAWINGS_FAILURE";

export const CREATE_NEW_DRAWING = "CREATE_NEW_DRAWING";
export const CREATE_NEW_DRAWING_SUCCESS = "CREATE_NEW_DRAWING_SUCCESS";
export const CREATE_NEW_DRAWING_FAILURE = "CREATE_NEW_DRAWING_FAILURE";

export const UPDATE_DRAWING = "UPDATE_DRAWING";
export const UPDATE_DRAWING_SUCCESS = "UPDATE_DRAWING_SUCCESS";
export const UPDATE_DRAWING_FAILURE = "UPDATE_DRAWING_FAILURE";

export const DELETE_DRAWING = "DELETE_DRAWING";
export const DELETE_DRAWING_SUCCESS = "DELETE_DRAWING_SUCCESS";
export const DELETE_DRAWING_FAILURE = "DELETE_DRAWING_FAILURE";

export const SEARCH_VALUE_DRAWING = "SEARCH_VALUE_DRAWING";
export const SORT_BY_DRAWING = "SORT_BY_DRAWING";
export const SELECTED_PAGE_DRAWING = "SELECTED_PAGE_DRAWING";

export const IS_TOUCHED_DRAWING = "IS_TOUCHED_DRAWING";

// Rules
export const GET_DRAWING_RULES = "GET_DRAWING_RULES";
export const GET_DRAWING_RULES_SUCCESS = "GET_DRAWING_RULES_SUCCESS";
export const GET_DRAWING_LAYER_SUCCESS = "GET_DRAWING_LAYER_SUCCESS";
export const GET_DRAWING_RULES_FAILURE = "GET_DRAWING_RULES_FAILURE";

export const GET_RULES = "GET_RULES";
export const GET_RULES_SUCCESS = "GET_RULES_SUCCESS";
export const GET_RULES_FAILURE = "GET_RULES_FAILURE";

export const DELETE_DRAWING_RULE = "DELETE_DRAWING_RULE";
export const DELETE_DRAWING_RULE_SUCCESS = "DELETE_DRAWING_RULE_SUCCESS";
export const DELETE_DRAWING_RULE_FAILURE = "DELETE_DRAWING_RULE_FAILURE";

export const UPDATE_RULE = "UPDATE_RULE";
export const UPDATE_RULE_SUCCESS = "UPDATE_RULE_SUCCESS";
export const UPDATE_RULE_FAILURE = "UPDATE_RULE_FAILURE";

export const CREATE_RULE = "CREATE_RULE";
export const CREATE_RULE_SUCCESS = "CREATE_RULE_SUCCESS";
export const CREATE_RULE_FAILURE = "CREATE_RULE_FAILURE";

export const NEW_RULE = "NEW_RULE";
export const NEW_RULE_SUCCESS = "NEW_RULE_SUCCESS";
export const NEW_RULE_FAILURE = "NEW_RULE_FAILURE";

export const DELETE_RULE = "DELETE_RULE";
export const DELETE_RULE_SUCCESS = "DELETE_RULE_SUCCESS";
export const DELETE_RULE_FAILURE = "DELETE_RULE_FAILURE";

// Layer
export const GET_LAYER = "GET_LAYER";
export const GET_LAYER_SUCCESS = "GET_LAYER_SUCCESS";
export const GET_LAYER_FAILURE = "GET_LAYER_FAILURE";

// Layer Rule
export const GET_LAYER_RULE = "GET_LAYER_RULE";
export const GET_LAYER_RULE_SUCCESS = "GET_LAYER_RULE_SUCCESS";
export const GET_LAYER_RULE_FAILURE = "GET_LAYER_RULE_FAILURE";

export const CREATE_LAYER_RULE = "CREATE_LAYER_RULE";
export const CREATE_LAYER_RULE_SUCCESS = "CREATE_LAYER_RULE_SUCCESS";
export const CREATE_LAYER_RULE_FAILURE = "CREATE_LAYER_RULE_FAILURE";

export const DELETE_LAYER_RULE = "DELETE_LAYER_RULE";
export const DELETE_LAYER_RULE_SUCCESS = "DELETE_LAYER_RULE_SUCCESS";
export const DELETE_LAYER_RULE_FAILURE = "DELETE_LAYER_RULE_FAILURE";

// Locale Reducer
export const LOCALE_SET_STARTED = "LOCALE_SET_STARTED";
export const LOCALE_SET_FULFILLED = "LOCALE_SET_FULFILLED";
export const LOCALE_SET_USER_ISADMIN_FULFILLED =
  "LOCALE_SET_USER_ISADMIN_FULFILLED";
export const LOCALE_SET_FAILED = "LOCALE_SET_FAILED";
export const UPDATE_MESSAGES = "UPDATE_MESSAGES";
export const LOCALE_UPDATE_USER_ROLES = "LOCALE_UPDATE_USER_ROLES";
export const LOCALE_SET_PROJECTS = "LOCALE_SET_PROJECTS";
export const LOCALE_SET_PROJECTS_TRANSLATIONS = "LOCALE_SET_PROJECTS_TRANSLATIONS";
export const UPDATE_TRANSLATIONS = "UPDATE_TRANSLATIONS";

